var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNearbyCustomerMapPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10796_22538)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_10796_22538)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-1-outside-1_10796_22538",
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 2,
    width: 16,
    height: 21,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 4,
    y: 2,
    width: 16,
    height: 21
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2954 9.71762C18.2954 7.936 17.595 6.22734 16.3483 4.96755C15.1016 3.70775 13.4108 3 11.6477 3C9.88461 3 8.19374 3.70775 6.94706 4.96755C5.70038 6.22734 5 7.936 5 9.71762C5.00005 11.3929 5.62253 13.0072 6.74422 14.2408C6.74422 14.2408 10.3941 18.3002 11.4008 21.0992C11.4187 21.1523 11.4526 21.1983 11.4977 21.231C11.5428 21.2636 11.5969 21.2811 11.6524 21.2811C11.7079 21.2811 11.762 21.2636 11.8071 21.231C11.8523 21.1983 11.8862 21.1523 11.9041 21.0992C12.9107 18.3002 16.5575 14.2408 16.5575 14.2408C17.6771 13.0064 18.2973 11.3921 18.2954 9.71762Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M18.2954 9.71762C18.2954 7.936 17.595 6.22734 16.3483 4.96755C15.1016 3.70775 13.4108 3 11.6477 3C9.88461 3 8.19374 3.70775 6.94706 4.96755C5.70038 6.22734 5 7.936 5 9.71762C5.00005 11.3929 5.62253 13.0072 6.74422 14.2408C6.74422 14.2408 10.3941 18.3002 11.4008 21.0992C11.4187 21.1523 11.4526 21.1983 11.4977 21.231C11.5428 21.2636 11.5969 21.2811 11.6524 21.2811C11.7079 21.2811 11.762 21.2636 11.8071 21.231C11.8523 21.1983 11.8862 21.1523 11.9041 21.0992C12.9107 18.3002 16.5575 14.2408 16.5575 14.2408C17.6771 13.0064 18.2973 11.3921 18.2954 9.71762Z",
    fill: "#87A4D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2954 9.71762C18.2954 7.936 17.595 6.22734 16.3483 4.96755C15.1016 3.70775 13.4108 3 11.6477 3C9.88461 3 8.19374 3.70775 6.94706 4.96755C5.70038 6.22734 5 7.936 5 9.71762C5.00005 11.3929 5.62253 13.0072 6.74422 14.2408C6.74422 14.2408 10.3941 18.3002 11.4008 21.0992C11.4187 21.1523 11.4526 21.1983 11.4977 21.231C11.5428 21.2636 11.5969 21.2811 11.6524 21.2811C11.7079 21.2811 11.762 21.2636 11.8071 21.231C11.8523 21.1983 11.8862 21.1523 11.9041 21.0992C12.9107 18.3002 16.5575 14.2408 16.5575 14.2408C17.6771 13.0064 18.2973 11.3921 18.2954 9.71762Z",
    stroke: "white",
    strokeWidth: 1.84967,
    mask: "url(#path-1-outside-1_10796_22538)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_10796_22538",
    x: 1.99432,
    y: -0.00567913,
    width: 19.3068,
    height: 24.2925,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.04044
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.121569 0 0 0 0 0.14902 0 0 0 0 0.278431 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10796_22538"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10796_22538",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10796_22538"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNearbyCustomerMapPin);
export default __webpack_public_path__ + "static/media/nearby-customer-map-pin.61fd94a7b0b652480f8b8b7acb9953b2.svg";
export { ForwardRef as ReactComponent };